<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">创建时间</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">状态</span>
        <el-select v-model="status" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.id"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">代理区域</span>
        <el-input v-model.trim="area" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">负责人</span>
        <el-input v-model.trim="person" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">代理商名称</span>
        <el-input v-model.trim="name" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getAgentPageFn()">
          搜索
        </el-button>
      </div>
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="editBtn(5)">
          新增
        </el-button>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="editBtn(6)">
          分成设置
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="agentName" label="代理商名称"></el-table-column>
      <el-table-column align="center" prop="realName" label="负责人"></el-table-column>
      <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
      <el-table-column align="center" prop="region" label="代理区域"></el-table-column>
      <el-table-column align="center" prop="agentType" label="代理商类型"></el-table-column>
      <el-table-column align="center" prop="divideIntoProp" label="分成比例(%)"></el-table-column>
      <el-table-column align="center" prop="userName" label="登录账号"></el-table-column>
      <el-table-column align="center" prop="userNum" label="用户数"></el-table-column>
      <el-table-column align="center" prop="openFlag" label="状态"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建日期"></el-table-column>
      <el-table-column align="center" label="操作" width="250px">
        <template slot-scope="{row}">
          <a class="glob-a" @click="editBtn(1, row)">查看</a>
          <a class="glob-a" @click="editBtn(2, row)">编辑</a>
          <a class="glob-a" @click="editBtn(3, row)">{{row.openFlagValue == 'NONPROHIBITED' ? '禁用' : '启用'}}</a>
          <a class="glob-a" @click="editBtn(4, row)">权限设置</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 新增编辑 -->
    <el-dialog :title="editData.add === 1 ? '新增' : '编辑'" :visible.sync="editData.modal" width="500px">
      <el-form label-width="120px">
        <el-form-item label="代理商类型：">
          <el-radio v-model="editData.userType" label="AGENT_PROVINCE">省级代理商</el-radio>
          <el-radio v-model="editData.userType" label="AGENT_CITY">市级代理商</el-radio>
        </el-form-item>
        <el-form-item label="登录名：">
          <el-input v-model.trim="editData.userName" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="初始密码：" v-if="editData.add === 1">
          <el-input v-model.trim="editData.password" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="代理商名称：">
          <el-input v-model.trim="editData.agentName" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="代理区域：">
          <el-input v-model.trim="editData.region" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="负责人：">
          <el-input v-model.trim="editData.realName" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="手机号：">
          <el-input v-model.trim="editData.phone" type="number" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="分成比例：">
          <el-input v-model.trim="editData.divideIntoProp" type="number" placeholder="请输入"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="editData.modal = false">取 消</el-button>
        <el-button type="primary" @click="addBtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分成比例 -->
    <el-dialog title="分成比例" :visible.sync="ratioData.modal" width="600px">
      <el-form label-width="200px">
        <el-form-item label="省级代理商分成比例范围：">
          <el-input v-model.trim="ratioData.proProportionRise" type="number" style="width: 160px;" placeholder="请输入"/>
          <span class="pl10 pr10">-</span>
          <el-input v-model.trim="ratioData.proProportionStop" type="number" style="width: 160px;" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="市级代理商分成比例范围：">
          <el-input v-model.trim="ratioData.cityProportionRise" type="number" style="width: 160px;" placeholder="请输入"/>
          <span class="pl10 pr10">-</span>
          <el-input v-model.trim="ratioData.cityProportionStop" type="number" style="width: 160px;" placeholder="请输入"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="ratioData.modal = false">取 消</el-button>
        <el-button type="primary" @click="ratioSave">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看" :visible.sync="msgModal" fullscreen>
      <detail :id="msgId"/>
    </el-dialog>

    <!-- 权限设置 -->
    <el-dialog title="系统权限设置" :visible.sync="authData.modal" fullscreen>
      <el-table class="my-table" :data="authData.tableData" :header-row-class-name="'my-table-header'">
        <el-table-column align="center" prop="lineNumber" width="100px" label="行号"></el-table-column>
        <el-table-column align="center" prop="name.name" width="300px" label="名称"></el-table-column>
        <el-table-column align="left" label="权限明细">
          <template slot-scope="{row}">
            <el-checkbox v-model="row.allCheck" @change="authAllChange($event, row)"
                         :indeterminate="row.indeterminate">
              全选
            </el-checkbox>
            <el-checkbox-group class="mt20" v-model="row.checkedList" @change="authChange($event, row)">
              <el-checkbox v-for="(item,index) in row.subNameList" :label="item.id" :key="index">
                {{item.name}}
              </el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
      </el-table>


      <div slot="footer">
        <el-button @click="authData.modal = false">取 消</el-button>
        <el-button type="primary" @click="authSave">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import Detail from './Detail'

  import {
    getAgentPage,
    addAgent,
    setAgent,
    setUserStatus,
    getAgentRatio,
    setAgentRatio,
    getUserPerm,
    addUserRoleFun
  } from '@/api'

  export default {
    name: 'AgentList',
    components: {Detail},
    data () {
      return {
        date: '',
        status: '',
        statusList: [
          {name: '禁用', id: 'PROHIBIT'},
          {name: '正常', id: 'NONPROHIBITED'},
        ],
        area: '',
        person: '',
        name: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        editData: {
          modal: false,
          userId: '',
          add: 1,
          userType: 'AGENT_PROVINCE',
          userName: '',
          password: '',
          agentName: '',
          region: '',
          realName: '',
          phone: '',
          divideIntoProp: ''
        },
        ratioData: {
          modal: false,
          proProportionRise: 0,
          proProportionStop: 0,
          cityProportionRise: 0,
          cityProportionStop: 0,
        },
        msgId: '',
        msgModal: false,
        // 权限设置
        authData: {
          modal: false,
          roleIdList: '',
          tableData: [],
          tableLoading: false,
        }
      }
    },
    created () {
      this.getAgentPageFn()
    },
    methods: {
      ratioSave () {
        setAgentRatio(this.ratioData).then(res => {
          this.ratioData.modal = false
          this.$message.success(res.data)
        })
      },
      addBtn (t) {
        if (this.editData.add == 1) {
          addAgent({
            userType: this.editData.userType,
            userName: this.editData.userName,
            password: this.editData.password,
            agentName: this.editData.agentName,
            region: this.editData.region,
            realName: this.editData.realName,
            phone: this.editData.phone,
            divideIntoProp: this.editData.divideIntoProp
          }).then(res => {
            this.editData.modal = false
            this.$message.success(res.data)
            this.getAgentPageFn()
          })
        } else {
          setAgent({
            userId: this.editData.userId,
            userType: this.editData.userType,
            userName: this.editData.userName,
            password: this.editData.password,
            agentName: this.editData.agentName,
            region: this.editData.region,
            realName: this.editData.realName,
            phone: this.editData.phone,
            divideIntoProp: this.editData.divideIntoProp,
          }).then(res => {
            this.editData.modal = false
            this.$message.success(res.data)
            this.getAgentPageFn()
          })
        }
      },
      // 1查看 2编辑 3禁用|启用 4权限设置 5新增 6分成设置
      editBtn (t, row) {
        switch (t) {
          case 1:
            this.msgId = row.userId
            this.msgModal = true
            break
          case 2:
            this.editData = {
              modal: true,
              userId: row.userId,
              add: 2,
              userType: row.agentTypeValue,
              userName: row.userName,
              password: '',
              agentName: row.agentName,
              region: row.region,
              realName: row.realName,
              phone: row.phone,
              divideIntoProp: row.divideIntoProp,
            }
            break
          case 3:
              var tips = row.openFlagValue == "NONPROHIBITED" ? "禁用" : "启用";
              this.$confirm(`确认${tips}吗`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              setUserStatus({
                userId: row.userId,
                openFlag: row.openFlagValue == 'NONPROHIBITED' ? 'PROHIBIT' : 'NONPROHIBITED'
              }).then(res => {
                this.$message.success(res.data)
                this.getAgentPageFn()
              })
            }).catch(() => {
            })
            break
          case 4:
            getUserPerm(row.userId).then(res => {
              let tableData = res.data
              tableData.forEach(item => {
                item.indeterminate = false
                item.allCheck = item.subNameList.every(subName => subName.flag)
                item.checkedList = item.subNameList.filter(subName => subName.flag).map(subName => subName.id)
              })
              this.authData = {
                modal: true,
                roleIdList: row.roleIdList,
                tableData
              }
            })
            break
          case 5:
            this.editData = {
              modal: true,
              userId: '',
              add: 1,
              userType: 'AGENT_PROVINCE',
              userName: '',
              password: '',
              agentName: '',
              region: '',
              realName: '',
              phone: '',
              divideIntoProp: ''
            }
            break
          case 6:
            getAgentRatio().then(res => {
              this.ratioData = {
                modal: true,
                proProportionRise: res.data.proProportionRise,
                proProportionStop: res.data.proProportionStop,
                cityProportionRise: res.data.cityProportionRise,
                cityProportionStop: res.data.cityProportionStop,
              }
            })
            break
        }
      },
      authAllChange (val, row) {
        row.checkedList = val ? row.subNameList.map(item => item.id) : []
        row.indeterminate = false
      },
      authChange (value, row) {
        let checkedCount = value.length
        row.allCheck = checkedCount === row.checkedList.length
        row.indeterminate = checkedCount > 0 && checkedCount < row.subNameList.length
      },
      authSave () {
        let data =  this.authData.tableData;
        let checkArray = [];
        data.forEach(item => {
          let subName = item.name;
          let subItem = item.checkedList;
          let length = subItem.length;
          //数组有值在追加到一起
          if(length!=0){
            let id = subName.id;
            checkArray.push(id);
            subItem.forEach(item =>{
              checkArray.push(item);
            });
          }
        });
        //一个用户可能分配多个角色
        let roleIdList = this.authData.roleIdList;
        let length = roleIdList.length;
        let roleId;
        if(length!=0){
          //这里分配默认取第一个角色
          roleId = roleIdList[0];
        }
        addUserRoleFun({
          roleId: roleId,
          functionIds: checkArray,
        }).then(res => {
          this.$message.success(res.data)
          this.authData.modal = false
        })
      },
      getAgentPageFn () {
        this.tableLoading = true
        getAgentPage({
          agentName: this.name,
          realName: this.person,
          region: this.area,
          openFlag: this.status,
          pageNum: this.pages.page,
          startTime: this.date && this.date.length ? this.date[0] : '',
          endTime: this.date && this.date.length > 1 ? this.date[1] : '',
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getAgentPageFn()
      },
    }
  }
</script>

<style scoped>

</style>
